import { AllowedOrBlockedEstablishments } from "@/features/privateCompanies/types/companyBranches.type";

export const establishmentOptionTransformer = (establishment: AllowedOrBlockedEstablishments) => ({
  label: `${establishment.establishment_branch?.general_information?.fantasy_name} (${establishment.establishment_branch?.general_information?.official_name})`,
  value: establishment.establishment_branch?.id,
})
